import * as React from "react"

import { APPLICATION_URL } from "features/Navigation"
import { Survey, Theme } from "models/Survey"
import * as Styles from "./SurveyCard.styles"
import { CustomSurveyInfo } from "./components/"

export const SurveyCard: React.FunctionComponent<ScheduledSurveyCardProps> = (props) => {
  const scheduledSurveyCard = (
    <Styles.SurveyCard
      $isActive={props.isActive}
      $isMini={props.isMini}
      $isInteractive={props.isInteractive}
      shadow="below"
    >
      <CustomSurveyInfo surveyTheme={props.theme} survey={props.survey} isMini={props.isMini} />
    </Styles.SurveyCard>
  )

  if (props.shouldNavigate && props.isInteractive) {
    return <Styles.CardLink to={APPLICATION_URL.editSurvey(props.survey.id)}>
      {scheduledSurveyCard}
    </Styles.CardLink>
  }

  return scheduledSurveyCard
}

SurveyCard.defaultProps = {
  shouldNavigate: true,
}

export interface ScheduledSurveyCardProps {
  /** Theme reference for this scheduled survey */
  theme: Theme,

  /** Survey reference for this scheduled survey */
  survey: Survey,

  /** Whether this card is selected in a list */
  isActive: boolean,

  /** Whether the card should appear interactive (hover effect and interaction cursor) */
  isInteractive: boolean,

  /** Whether the card should appear in its minified version */
  isMini: boolean,

  /** Whether to navigate to the scheduled survey on click */
  shouldNavigate: boolean,

  /** We need to adapt content width depending of the visibility of the scrollbar */
  isScrollbarVisible?: boolean,
}
